import { FindADealerFields, FindADealerProps } from "./fields.definitions";
import { ImageField, LinkField, StringField } from "../../types/types";
type ValueOf<T> = T[keyof T];

export class FindADealerModel {
    private readonly fields: null | FindADealerFields;
    constructor(props: FindADealerProps) {
        this.fields = props.fields || null;
    }

    private getterFn(fieldName: 'Title' | 'Description' |  'Search Placeholder Text' | 'Location Button Text' , defaultValue: string) : StringField
    private getterFn(fieldName: 'Link' , defaultValue: { href?: string, text?: string }) : LinkField
    private getterFn(fieldName: 'Image' , defaultValue: { src?: string}) : ImageField
    // private getterFn(fieldName: keyof FindADealerFields, defaultValue: (StringField | LinkField | ImageField)['value']) : (StringField | LinkField | ImageField)
    private getterFn(fieldName: keyof FindADealerFields, defaultValue: (ValueOf<FindADealerFields>)['value']='')  {
        if (this.fields && this.fields[fieldName]) {
            return this.fields[fieldName];
        }
        return {value: defaultValue};

    }

    get title(): StringField {
        const defaultValue = 'Find a Dealer';
        return this.getterFn('Title', defaultValue);
    }

    get content(): StringField {
        const defaultValue = '<p>Locate a dealer and book an appointment to find your perfect machine</p>';
        return this.getterFn('Description', defaultValue);
    }

    get inputPlaceholder(): StringField {
        const defaultValue = 'Search by city, state or province';
        return this.getterFn('Search Placeholder Text', defaultValue);
    }

    get inputPlaceholderText(): string {
        return this.inputPlaceholder.value ?? 'Search by city, state or province';
    }

    get searchButton() : LinkField {
        return this.getterFn('Link', {href: '#', text: 'SEARCH'});
    }

    get backgroundImage() : ImageField {
        return this.getterFn('Image', {src: '//localhost:8085/images/FindADealer.jpg'});
    }

    get locateMeButton(): StringField {
        return this.getterFn('Location Button Text', 'USE MY LOCATION');
    }

    get searchButtonText(): string {
        return this.searchButton?.value?.text ?? 'SEARCH';
    }

    get searchUrl(): string {
        return this.searchButton?.value?.href ?? '#';
    }
}
